import { Banner, Pagination, Sort } from '@shared/data';
import { CbDataTableOptions, CbDataTableColumnType } from './../../cb-data-table';

export class BannerListDataTableOptions implements CbDataTableOptions<Banner> {
  noResult = "common.noResult";
  header = true;
  lang = 'en';
  columns = [
    {
      type: CbDataTableColumnType.IMAGE,
      label: 'banner.image',
      value: (o: Banner) => {
        return o.items[0].getImage(this.lang) ? o.items[0].getImage(this.lang).url : '';
      }
    },
    {
      type: CbDataTableColumnType.TEXT,
      label: 'banner.position',
      value: (o: Banner) => {
        return o.option ? o.option.position : '';
      }
    },
    {
      type: CbDataTableColumnType.STATUS,
      label: 'common.status',
      value: (o: Banner) => {
        return o.enabled;
      }
    }
  ];

  editable(o): boolean {
    return false;
  };

  deletable(o): boolean {
    return false;
  };
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+banner/banner-list/banner-list.data-table-options.ts